<template>
  <section id="user-customers" class="my-8">
    <v-row class="d-flex justify-center">
      <v-col cols="12" md="10" lg="10">
        <card-widget>
          <template #cardBody>
            <v-row no-gutters align="start">
              <v-col cols="12" lg="3" md="3">
                <h5
                  class="
                    text-h6
                    secondary--font
                    font-weight-large
                    text--primary
                    pb-6
                  "
                >
                  {{ $dictionary.app.manageUsers.user.customers.title }}
                </h5>
              </v-col>
              <v-spacer />
              <v-col
                cols="12"
                lg="5"
                md="5"
                class="d-flex justify-space-between overflow-auto"
              >
                <v-spacer />
                <debounce-search-text-field
                  propToSearch="name"
                  :sort-by="sortConfig.sortBy"
                  :lazy-search="getCustomerslist"
                  placeholder="Search Customer..."
                  :sort-order="sortConfig.sortOrder"
                  :no-of-records="customerParams.per_page"
                  @search-value="customerSearch = $event"
                />
              </v-col>
            </v-row>
            <user-customers-table
              :headers="headers"
              :data="customers"
              :is-loading="isLoading"
              default-sort-order="name"
              @get-records="getCustomerslist"
            >
              <template #record="{item}">
                <table-matrics-row
                  is-link
                  is-text-pointer
                  :text="item.name"
                  text-class="blue--text"
                  :query="{ active_tab: 'owners' }"
                  :navigate-to="`${$paths.customers}/${item.id}/customer`"
                />
              </template>
            </user-customers-table>
          </template>
        </card-widget>
      </v-col>
    </v-row>
  </section>
</template>

<script>
import { CardWidget } from "@/components/widgets";
import { UserCustomersTable } from "@/components/tables";
import { userCustomersHeaders as headers } from "@/data/table-headers";

import { SharedUtilsMixin } from "@/mixins";
import { getUserCustomers } from "@/services";
import { hasProp, getName } from "@/utils/common.utils";
import { DebounceSearchTextField } from "@/components/shared";
import { TableMatricsRow } from "@/components/shared";
/**
 * User Customers tab
 */
export default {
  name: "UserCustomers",
  /**
   * ---------------- Mixins ------------------
   */
  mixins: [SharedUtilsMixin],
  /**
   * ---------------- Components ------------------
   */
  components: {
    CardWidget,
    TableMatricsRow,
    UserCustomersTable,
    DebounceSearchTextField,
  },
  /**
   * ---------------- Data properties ------------------
   */
  data() {
    return {
      headers,
      customers: [],
      isLoading: false,
      customerParams: {},
      customerSearch: "",
    };
  },
  /**
   * ---------------- Computed properties ------------------
   */
  computed: {
    /**
     * User customers listing sorting configuration
     */
    sortConfig() {
      return this.getSortConfig("customerParams", "name");
    },
    /**
     * Id of the user whose record is being displayed
     * @type {String}
     */
    userId() {
      const { id } = this.$route.params;
      return id;
    },
  },
  /**
   * ---------------- Methods ------------------
   */
  methods: {
    getName,
    /**
     * Fetches customer list
     * @param {Object} params Customer get api request params
     */
    async getCustomerslist(params = this.customerParams) {
      try {
        if (this.customerSearch && !hasProp(params, "q[name_cont]")) {
          params["q[name_cont]"] = this.customerSearch;
        }
        this.customerParams = params;
        this.isLoading = true;

        const { data } = await getUserCustomers(this.userId, params);
        this.customers = data ?? [];
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
